import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ContentSegment } from "./media-utils";
import MediaThumbnail from "./MediaThumbnail";
interface ContentSegmentComponentProps {
  readonly segment: ContentSegment;
  readonly index: number;
}

/**
 * Component to render a single segment of content (text or media)
 */
export default function ContentSegmentComponent(t0) {
  const $ = _c(6);
  const {
    segment,
    index
  } = t0;
  if (segment.type === "text") {
    const t1 = `segment-${index}`;
    let t2;
    if ($[0] !== segment.content || $[1] !== t1) {
      t2 = <span key={t1}>{segment.content}</span>;
      $[0] = segment.content;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (segment.mediaInfo) {
    const t1 = `segment-${index}`;
    let t2;
    if ($[3] !== segment.mediaInfo || $[4] !== t1) {
      t2 = <MediaThumbnail key={t1} media={segment.mediaInfo} />;
      $[3] = segment.mediaInfo;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  return null;
}